export const ALPHABET_LIST = Array.from({ length: 26 }, (_, i) =>
  String.fromCharCode(65 + i),
);

const VALID_ALPHABET = new Set(ALPHABET_LIST);

export const normalizeAlphabetPrefix = (prefix?: string): string => {
  if (!prefix) return '';
  const upper = prefix.toUpperCase();
  return VALID_ALPHABET.has(upper) ? upper : '';
};
